'use strict';

/*global blockElement*/
/*global unBlockElement*/
/*global createObjectCallBack*/
/*global services*/
/*global initialize*/

function Dashboard(containerID) {
  this.containerID = containerID;
  this.$container = null;
  this.$submitActor = null;

  this.init();
}

Dashboard.prototype = $.extend({}, {
  constructor: 'Dashboard',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    $('body').on('click', '#' + _this.containerID + ' .order-by', function () {
      _this.loadWidget($(this).closest('.widget'), $(this).closest('.widget').find('.widget-filter form'), $(this).data('order_by'));
      return false;
    });

    $('body').on('submit', '#' + _this.containerID + ' .widget-filter form', function () {
      _this.loadWidget($(this).closest('.widget'), $(this));
      return false;
    });
  },

  //----------------------------------------------------------------------------

  widgetScrollHandler: function widgetScrollHandler($widget) {
    var _this = this;

    $widget.trigger('scrollWidget');

    return _this;
  },

  getErrorLoadingMessage: function getErrorLoadingMessage() {
    var message = '<div class="widget-message-wrapper">';
    message +=      '<span class="widget-message">';
    message +=        '<span class="glyphicon glyphicon-warning-sign"></span> ' + services.get('translator').trans('dashboard.loading.error');
    message +=      '</span>';
    message +=    '</div>';

    return message;
  },

  loadWidget: function loadWidget($widget, $form, orderBy, parameters, callBack) {
    var _this = this;

    var $widgetContent = $widget.find('.widget-content');

    parameters = parameters || '';

    if ($form && $form.length) {
      parameters += (parameters ? '&' : '') + $form.serialize();
    }

    if (orderBy) {
      parameters += (parameters ? '&' : '') + $widget.data('filter_prefix') + 'orderBy=' + orderBy;
    }

    if (_this.$submitActor) {
      parameters += (parameters ? '&' : '') + _this.$submitActor.prop('name') + '=' + _this.$submitActor.prop('value');
    }

    _this.$submitActor = null;

    blockElement($widgetContent.parent());
    $.get(services.get('router').path('load_widget', { dashboardId: _this.$container.data('dashboard_id'), dashboardWidgetId: $widget.data('dashboard_widget_id'), widgetId: $widget.data('widget_id') }), parameters, function (res) {
      unBlockElement($widgetContent.parent());

      if (res.msg === 'SUCCESS') {
        $widgetContent.empty();
        $widgetContent.html(res.data.html);
        initialize($widgetContent, _this);
        $widget.trigger('loadWidgetContent');

        if (callBack) {
          callBack(res.data);
        }
      } else {
        $widgetContent.html(_this.getErrorLoadingMessage());
      }
    });

    return _this;
  },

  invalidWidgets: function invalidWidgets(widgetID, parameters) {
    var _this = this;

    _this.$container.find('.widget[data-widget_id="' + widgetID + '"]').each(function () {
      _this.loadWidget($(this), null, null, parameters);
    });

    return _this;
  },

  invalidWidgetsByTag: function invalidWidgetsByTag(tag, parameters) {
    var _this = this;

    _this.$container.find('.widget[data-tags*="' + tag + '"]').each(function () {
      _this.loadWidget($(this), null, null, parameters);
    });

    return _this;
  },

  loadWidgets: function loadWidgets() {
    var _this = this;

    _this.$container.find('.widget:not(.loaded)').each(function () {
      _this.loadWidget($(this));
      _this.initWidget($(this));
    });

    return _this;
  },

  initWidget: function initWidget($widget) {
    var _this = this;

    $widget.find('.widget-content').bind('scroll', createObjectCallBack(_this, 'widgetScrollHandler', $widget));

    return _this;
  },

  init: function init() {
    var _this = this;

    _this.$container = $('#' + _this.containerID);

    if (_this.$container.length) {
      _this.registerCallbacks();
      _this.loadWidgets();
    }
  }
});
